import { SET_COMPANY_INFOS } from './types';

export function setCompanyInfo(businessId, companyInfo) {
	return {
		type: SET_COMPANY_INFOS,
		businessId,
		companyInfo
	};
}